// extracted by mini-css-extract-plugin
export default {"root":"SkHUmcbKYC","root_fillHeight":"umslR2UjMt","content":"BVyUNMREmv","tabPanel":"tP0YbH6cEz","header":"DIT__WRfjy","tabPanel_active":"HsMsLl0KyI"};